import type { MetricsResponse } from "@shared/types";
import { formatRelative, isStale } from "@/lib/format";

interface FreshnessFooterProps {
  freshness: MetricsResponse["freshness"];
  now?: Date;
  staleThresholdMins?: number;
}

interface Source {
  key: keyof MetricsResponse["freshness"];
  label: string;
}

const SOURCES: Source[] = [
  { key: "whatsapp", label: "WhatsApp" },
  { key: "voice", label: "Voice" },
  { key: "shopify", label: "Shopify" },
];

export function FreshnessFooter({
  freshness,
  now,
  staleThresholdMins = 30,
}: FreshnessFooterProps) {
  return (
    <div className="freshness" data-testid="freshness-footer">
      {SOURCES.map((src, i) => {
        const ts = freshness[src.key];
        const stale = isStale(ts, staleThresholdMins, now);
        return (
          <span className="freshness-item" key={src.key}>
            {stale && (
              <span
                className="freshness-dot"
                data-testid={`freshness-dot-${src.key}`}
                aria-label={`${src.label} source stale`}
              />
            )}
            <span className="freshness-source">{src.label}:</span>
            <span>{formatRelative(ts, now)}</span>
            {i < SOURCES.length - 1 && (
              <span style={{ marginLeft: 4 }}>·</span>
            )}
          </span>
        );
      })}
    </div>
  );
}
